<template>
	<div class="container-table">
		<modal
			v-if="myModalStatus"
			title="Adicionar"
			:getmodal-data="modalData"
			@closemodal="$store.dispatch('setModalPagamento', false)"
			@savedata="saveDataModal($event)"
		/>
		<cmodal
			v-if="editModalStatus"
			title="Editar"
			@closemodal="$store.dispatch('setEditModalPagamento', false)"
		>
			<div slot="modalcontent" class="modalContainerBox">
				<div class="modal-container-custom">
					<b-field label="Descrição" custom-class="is-small">
						<b-input v-model="form.descricao" size="is-small" disabled />
					</b-field>
					<b-field label="Vincular às condições de pagamento" custom-class="is-small">
						<treeselect
							v-model="form.condpgto"
							value-format="object"
							:multiple="true"
							:async="true"
							:load-options="loadOptions"
							size="small"
							:disabled="true"
						/>
					</b-field>
					<b-field label="Vincular às empresas" custom-class="is-small">
						<treeselect
							v-model="form.empresa"
							value-format="object"
							:multiple="true"
							:async="true"
							:load-options="myEmpresaOptions"
							size="small"
							:disabled="true"
						/>
					</b-field>
					<b-field label="Tipo" custom-class="is-small">
						<treeselect
							v-model="form.tipo"
							:multiple="false"
							:async="false"
							:options="tipoOptions"
							size="is-small"
						/>
					</b-field>
					<b-field label="Status" custom-class="is-small">
						<div class="field">
							<b-switch v-model="form.status" :true-value="1" :false-value="0" size="is-small" disabled>
								{{ form.status === 0 ? 'Inativo' : 'Ativo' }}
							</b-switch>
						</div>
					</b-field>
				</div>
				<div class="button-container">
					<b-button
						type="is-success"
						size="is-small"
						style="width: 30%"
						@click="saveDataEdit(form)"
					>
						Salvar
					</b-button>

					<b-button type="is-danger" size="is-small" style="width: 30%; margin-left: 20px">
						Cancelar
					</b-button>
				</div>
			</div>
		</cmodal>
		<cadtable :data="data" @editaction="getModalEditData(true, $event)" />
	</div>
</template>

<script>
import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import cadtable from '../../layout/components/table/cadtable';
import cmodal from '../../layout/components/modal/modal';
import modal from '../../layout/components/modal/index';
import * as ecAxios from '../../util/ecAxios';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
	components: {
		cadtable,
		modal,
		cmodal,
		Treeselect,
	},
	data() {
		return {
			data: [],
			showmodal: true,
			showEditModal: false,
			additional_grouped: [],
			selectedModalEdit: {},
			form: {
				descricao: '',
				status: 0,
				id: 0,
				condpgto: null,
				integracao_id: '',
				empresa: null,
				tipo: null,
				associado_id: 1,
			},
			editmodalData: [],
			tipoOptions: [
				{
					id: 1,
					label: ' 1 | Boleto a prazo',
				},
				{
					id: 2,
					label: ' 2 | Cartão de crédito',
				},
				{
					id: 3,
					label: ' 3 | Transferência Bancária',
				},
				{
					id: 4,
					label: ' 4 | Dinheiro',
				},
				{
					id: 5,
					label: ' 5 | Cheque',
				},
				{
					id: 6,
					label: '6 | Boleto à vista',
				},
			],
			modalData: {
				condpgtos: [],
				empresas: [],
			},
		};
	},
	computed: {
		tipoOptionsFormatted() {
			const optionsFormatted = [];
			this.tipoOptions.forEach((item) => {
				if (item.id && item.label) {
					optionsFormatted[item.id] = (item.label);
				}
			});
			return optionsFormatted;
		},
		myModalStatus() {
			return this.$store.getters.getModalPagamento;
		},
		editModalStatus() {
			return this.$store.getters.getEditModalPagamento;
		},
	},
	beforeMount() {
		this.getDataModal();
		this.getDataTable();
	},
	methods: {
		async getDataTable() {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_FORMAS_PAGAMENTO}`)
				.then((response) => {
					this.data = response.data.formpgtos.map((element) => {
						if (element && element.tipo) {
							element.tipo = this.tipoOptionsFormatted[element.tipo] || element.tipo;
						}
						return element;
					});
					console.log(this.data);
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-warning',
					});
				});
		},
		async saveDataModal(dataModal) {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}/formpgto/`, dataModal)
				.then((response) => {
					if (response.status === 200) {
						this.$buefy.notification.open({
							message: response.data.message,
							type: 'is-success',
						});
						this.$store.dispatch('setModalPagamento', false);
						this.getDataTable();
					} else {
						this.$buefy.notification.open({
							message: 'Informações Incorretas, verifique os campos e tente novamente',
							type: 'is-sucess',
						});
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-warning',
					});
				});
		},
		async saveDataEdit(form) {
			let condPgtId = [];
			let empresaId = [];
			condPgtId = form.condpgto.map((item) => item.id);
			empresaId = form.empresa.map((item) => item.id);
			await ecAxios
				.connection()
				.put(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_FORMAS_PAGAMENTO_SALVAR}${form.id}`, {
					associado_id: form.associado_id,
					condpgto: condPgtId,
					descricao: form.descricao,
					empresa: empresaId,
					integracao_id: form.integracao_id,
					status: form.status,
					tipo: form.tipo,
				})
				.then((response) => {
					if (response.data.error === 0) {
						window.location.reload();
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
		},
		async getDataModal() {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_COND_PAGAMENTO}`)
				.then((response) => {
					this.modalData.condpgtos = response.data.condpgtos;
				})
				.catch((error) => {
					this.error = error;
				});

			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_EMPRESA}`)
				.then((response) => {
					this.modalData.empresas = response.data.empresas;
				})
				.catch((error) => {
					this.error = error;
				});
		},
		showmodalaction(action, event) {
			if (action === false) {
				this.showmodal = false;
			} else {
				this.$store.dispatch('setModalData', event);
				this.showmodal = true;
			}
		},

		async getModalEditData(action, event) {
			await ecAxios
				.connection()
				.get(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_FORMAS_PAGAMENTO_SALVAR}${event.id}`)
				.then((response) => {
					if (!response.data.error) {
						const data = response.data.formpgto;
						this.form.descricao = data.descricao;
						this.form.integracao_id = data.integracao_id;
						this.form.status = data.status;
						this.form.tipo = data.tipo;
						this.form.id = data.id;
						this.showForm = true;
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_COND_PAGAMENTO}`, {
					formpgto_id: event.id,
				})
				.then((response) => {
					if (!response.data.error) {
						this.form.condpgto = [];
						response.data.condpgtos.forEach((element) => {
							this.form.condpgto.push({
								id: element.id,
								label: `ID: ${element.id} | ${element.descricao} | ID Integração: ${element.integracao_id}`,
							});
						});
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});

			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_EMPRESA}`, {
					formpgto_id: event.id,
				})
				.then((response) => {
					if (!response.data.error) {
						this.form.empresa = [];
						response.data.empresas.forEach((element) => {
							this.form.empresa.push({
								id: element.id,
								label: `${element.fantasia} | CPF/CNPJ:${element.cpfcnpj}`,
							});
						});
					}
				})
				.catch((e) => {
					// eslint-disable-next-line no-console
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
			this.$store.dispatch('setEditModalPagamento', action);
		},
		myEmpresaOptions({ action, searchQuery, callback }) {
			if (action === ASYNC_SEARCH) {
				const empresas = [];
				this.modalData.empresas.map((i) => {
					if (i.fantasia.includes(searchQuery)) {
						empresas.push({
							id: i.id,
							label: i.fantasia,
						});
						return true;
					}
					return false;
				});
				callback(null, empresas);
			}
		},
		loadOptions({ action, searchQuery, callback }) {
			if (action === ASYNC_SEARCH) {
				const condpgtosResult = [];
				this.modalData.condpgtos.map((i) => {
					if (i.descricao.includes(searchQuery)) {
						condpgtosResult.push({
							id: i.id,
							label: i.descricao,
						});
						return true;
					}
					return false;
				});
				callback(null, condpgtosResult);
			}
		},
	},
};
</script>

<style lang="css" scoped>
.modalContainerBox {
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	height: 100%;
}
.button-container {
	box-sizing: border-box;
	width: 100%;
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.container-table {
	width: 100%;
	padding: 13px;
	background-color: #fff;
}
.container-empresas {
	height: 50px;
}
.modal-container-custom {
	box-sizing: border-box;
	max-height: 78vh;
	overflow-x: auto;
}
.modal-container-custom::-webkit-scrollbar {
	width: 6px;
}
.modal-container-custom::-webkit-scrollbar-track {
	width: 6px;
	background: rgb(212, 212, 212);
	border-radius: 3px;
}

.modal-container-custom::-webkit-scrollbar-thumb {
	background: rgb(143, 209, 253);
	border-radius: 10px;
}
</style>

